const ITEM = "form-item";
const ITEM_COPIED = "form-item-copy";
const SECTION = "form-section";
const SECTION_COPIED = "form-section-copy";
const SHARED_SECTION = "form-shared-section";
const SHARED_SECTION_COPIED = "form-shared-section-copy";
const SHARED_SECTION_ITEM = "form-shared-section-item";
const SHARED_SECTION_ITEM_COPIED = "form-shared-section-item-copy";

const FORMS_DND_ITEMS = {
    ITEM,
    ITEM_COPIED,
    SECTION,
    SECTION_COPIED,
    SHARED_SECTION,
    SHARED_SECTION_COPIED,
    SHARED_SECTION_ITEM,
    SHARED_SECTION_ITEM_COPIED,
    NOT_COPIED: [ITEM, SECTION, SHARED_SECTION, SHARED_SECTION_ITEM],
    ITEM_ANY: [
        ITEM,
        ITEM_COPIED,
        SHARED_SECTION_ITEM,
        SHARED_SECTION_ITEM_COPIED
    ],
    SECTION_ANY: [
        SECTION,
        SECTION_COPIED,
        SHARED_SECTION,
        SHARED_SECTION_COPIED
    ],
    ANY: [
        ITEM,
        ITEM_COPIED,
        SECTION,
        SECTION_COPIED,
        SHARED_SECTION,
        SHARED_SECTION_COPIED,
        SHARED_SECTION_ITEM,
        SHARED_SECTION_ITEM_COPIED
    ],
    NULL: "form-read-only"
};

export default FORMS_DND_ITEMS;
